import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-property',
  templateUrl: './search-property.component.html',
  styleUrls: ['./search-property.component.css']
})
export class SearchPropertyComponent implements OnInit {

  env = environment;

  region_id = '';
  name = '';
  email = '';
  mobile_no = '';
  address = '';
  ulb_id: any = '';
  modelData: any = {};
  ulb_data: any = [];
  property_list: any = [];

  page: any = 1;
	perPage = 20;
  totalCount = 0;

  constructor(private apiService : ApiService,  
    private appComponent: AppComponent) { }

  ngOnInit(): void {
    // this.getUlbDataList();
    if(this.env.environmentName = "srinagar"){
      this.ulb_id = this.env.ulb_id;
      this.onUlbChange();
   }
  }

  getModelData(field_name : string) {
    this.appComponent.showLoader();
    this.apiService.get('model_data_public/2?ulb_id=' + this.ulb_id +'&logical_region=no').subscribe(res => {
      this.modelData[field_name] = JSON.parse(JSON.stringify([res.data]));
      this.modelData[field_name][0]['field_index'] = 0;
      this.modelData['regionHierarchyUlb'][0].ngmodel = '';
      this.appComponent.hideLoader();

    }, 
    (error) =>{
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    });
  }

  // getUlbDataList(){
  //   this.apiService.get(`public_ulbs`).subscribe((res) =>{
  //     this.ulb_data = res.data;
  //   },
  //   (error) =>{
  //     this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
  //   })
  // }

  getSearviceNumberList(){
    this.appComponent.showLoader();
    this.apiService.getCitizenData(`search_property?page=${this.page}&perpage=${this.perPage}&region_id=${this.region_id}&address=${this.address}&name=${this.name}&service_type=&mobile_no=${this.mobile_no}&email=${this.email}`).subscribe(
      (res:any) =>{
      this.property_list = res['data'];
      this.totalCount = res.total;
      this.appComponent.hideLoader();
    },
    (error) =>{
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    })
  }

  onSearchClick(){
    this.getSearviceNumberList();
  }

  modelChange(_value : any, _model: any, field_name: any, _index: any, model_id:any) {

    let modelData = JSON.parse(JSON.stringify(this.modelData[field_name]));

    let i = modelData.length; //initialize counter to array length

    while (i--) //decrement counter
    {
      if ((this.modelData[field_name][i] && this.modelData[field_name][i].field_index) > _index) {
        this.modelData[field_name].splice(i, 1);
      }

    }

    this.region_id = _value.value;

    if (_value.field_data.length <= 0) {

    }
    else {
      let index = this.modelData[field_name].findIndex((item: any) => item.field_label == _value.field_label);
      if (index == -1) {
        _value.field_index = _index + 1;
        _value.ngmodel = '';
        this.modelData[field_name].push(_value);
      }
    }

  }

  onUlbChange(){
    this.getModelData('regionHierarchyUlb');
  }


}
